(() => {
  if (window.rfHomepageMediaReady) return;
  window.rfHomepageMediaReady = true;
  function init(root = document) {
    root.querySelectorAll('.rf-engagement__video-track').forEach(track => {
      if (track.dataset.rfMediaReady) return;
      track.dataset.rfMediaReady = 'true';
      const section = track.closest('.rf-engagement');
      const buttons = section.querySelectorAll('[data-rf-video-scroll]');
      const update = () => {
        const hasOverflow = track.scrollWidth > track.clientWidth + 2;
        buttons.forEach(button => {
          button.disabled = !hasOverflow ||
            (button.dataset.rfVideoScroll === 'prev' && track.scrollLeft <= 2) ||
            (button.dataset.rfVideoScroll === 'next' && track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const direction = button.dataset.rfVideoScroll === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * Math.max(280, track.clientWidth * .8), behavior: 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
